module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-bar3-0b66b33d3eabd096f6239c6bd5d860fc.svg";